import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Usermanagement } from "./usermanagement.model";

@Injectable({
  providedIn: 'root'
})
export class UsermanagementService {

  selectedUser: Usermanagement;
  userList: Usermanagement[];

  constructor(private httpClient: HttpClient) { }

  getBaseUrl() {  
    return environment.baseUrl;
  }  

  FetchUserbyId(user: Usermanagement) {
    var body = user;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/StaffManagement/Fetch', body, { headers: headers });
  }

  IUDUser(userManagement: Usermanagement) {
    userManagement.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    userManagement.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    // hiding because we dealing with the User or Staff.
    // userManagement.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    userManagement.SaasId =  JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    let body = userManagement;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/StaffManagement/IUD', body, { headers: headers });
  }

  GetRolesList(){

    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() + 'api/Role/FetchList', body, {headers: headers });
  }


}
